module.exports = __webpack_public_path__ + "static/media/Home.45ba5680.jpg";